import { useEffect, useState } from "react";
import axios from "axios";
import { ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Short privacy notice plus optional consent, for every screen where a customer
 *  gives us information. Uses plain axios so it works on the public pages too. */
export const PrivacyNotice = ({ branch, accepted, onChange, testid = "privacy" }) => {
  const [notice, setNotice] = useState("");

  useEffect(() => {
    axios
      .get(`${API}/public/privacy`, { params: branch ? { branch } : {} })
      .then(({ data }) => setNotice(data.short_notice))
      .catch(() => setNotice(""));
  }, [branch]);

  return (
    <div className="border border-[#C5A059] bg-[#FBF8F2] p-4" data-testid={`${testid}-notice`}>
      <div className="flex items-center gap-2">
        <ShieldCheck className="h-4 w-4 text-[#C5A059]" />
        <span className="text-[11px] font-semibold uppercase tracking-widest text-[#8A6A22]">
          Your privacy
        </span>
      </div>
      <p className="mt-2 text-xs leading-relaxed text-muted-foreground">
        {notice ||
          "We collect your details to identify you and to keep the records the law requires."}{" "}
        <a
          href={`/privacy?branch=${branch || ""}`}
          target="_blank"
          rel="noreferrer"
          className="font-semibold text-[#8A6A22] underline"
          data-testid={`${testid}-policy-link`}
        >
          Read the full privacy policy
        </a>
      </p>
      {onChange && (
        <label className="mt-3 flex cursor-pointer items-start gap-2 text-xs">
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => onChange(e.target.checked)}
            className="mt-0.5 accent-[#C5A059]"
            data-testid={`${testid}-accept-checkbox`}
          />
          <span>
            I have read the privacy notice and agree to Dhunna Jewellers collecting and holding
            my information for the reasons described.
          </span>
        </label>
      )}
    </div>
  );
};
